import React from 'react'

import { Route } from 'wouter'
import type { RoutesInfo } from 'routes/types'

const Voucher = React.lazy(() => import('../pages/voucher'))

export const TravelRoutesInfo: Record<string, RoutesInfo> = {
  voucher: { path: '/travel/voucher' },
}

export const TravelModule: React.FC = () => (
  <>
    <Route path={TravelRoutesInfo.voucher.path} component={Voucher} />
  </>
)
